import { render, staticRenderFns } from "./PracticeSwitcher.vue?vue&type=template&id=d895ebfa&scoped=true&"
import script from "./PracticeSwitcher.vue?vue&type=script&lang=js&"
export * from "./PracticeSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./PracticeSwitcher.vue?vue&type=style&index=0&id=d895ebfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d895ebfa",
  null
  
)

export default component.exports